export default __webpack_public_path__ + "static/media/superhero.04f0f3a8.jpg";